import { IconContent } from '@icons';

export const tube: IconContent = {
    md: '<path fill-rule="evenodd" d="m20.985 8.964-4.95-4.95-2.12 2.122 4.949 4.95 2.121-2.122Zm-4.242-5.656a1 1 0 0 0-1.414 0l-2.122 2.12a1 1 0 0 0 0 1.415l-7.425 7.425a3.5 3.5 0 1 0 4.95 4.95l7.425-7.425a1 1 0 0 0 1.414 0l2.121-2.121a1 1 0 0 0 0-1.415l-4.95-4.95ZM10.025 18.51l7.425-7.424-3.536-3.536L12.5 8.964l1.414 1.415-4.95 4.95-1.414-1.415-1.06 1.06a2.5 2.5 0 1 0 3.535 3.536Z" />',
};
